// contexts/BuilderContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';

const BuilderContext = createContext();

export const useBuilder = () => useContext(BuilderContext);

const formatCash = (wgt)=> {
    return {
        id: 'custodial_cash',
        name: "Custodial Cash",
        type: 'cash',
        wgt: wgt,
        _locked: true
    }
}

export const BuilderProvider = ({ children }) => {
    const initialPortfolioBuilderState = {
        id: null,
        title: '',
        type: 'm',
        items: [formatCash(0)],
        stateId: null
    };

    const [portfolioBuilder, setPortfolioBuilder] = useState(initialPortfolioBuilderState);

    const setNewPortfolioBuilderContext = ({type='m', items=[], name=''}) => {
        setPortfolioBuilder({
            id: null,
            title: name,
            type: type,
            items: [formatCash(0), ...items],
            stateId: null
        });

    };
    // Function to set an existing portfolio into the builder's context
    const setExistingPortfolioBuilderContext = (portfolio) => {

        const unwindToArray = (o)=>{
            let a = [];
            for (let k in o){
                a.push({id: k, name: o[k].name, wgt: o[k].wgt * 100, type: o[k].type});
            }
            return a;
        }
        let items = unwindToArray(portfolio.ptfl);
        items.unshift(formatCash(portfolio.cash));
        setPortfolioBuilder({
            id: portfolio.id,
            title: portfolio.name,
            type: portfolio.type,
            items: items,
            stateId: null
        });
    };

    const resetPortfolioBuilderContext = (type) => {
        setPortfolioBuilder({...initialPortfolioBuilderState, type: type});
    };



    return (
        <BuilderContext.Provider value={{
            portfolioBuilder, setPortfolioBuilder,
            resetPortfolioBuilderContext,
            setNewPortfolioBuilderContext,
            setExistingPortfolioBuilderContext,
        }}>
            {children}
        </BuilderContext.Provider>
    );
};
